<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="140" height="140" viewBox="0 0 140 140" fill="none">
    <g clip-path="url(#clip0_5586_289768)">
      <path
        d="M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z"
        fill="#F6F7F8"
      />
      <g opacity="0.75">
        <path
          opacity="0.75"
          d="M99.9581 73.3414L127.279 29.3553C123.553 23.99 119.09 19.1776 114.023 15.0601L76.0771 73.3414H99.9581Z"
          fill="white"
        />
      </g>
      <g opacity="0.75">
        <path
          opacity="0.75"
          d="M0.249332 73.3419H25.7147L69.4109 0.0253906C57.1179 0.17535 45.0823 3.57486 34.5208 9.88019L0.609153 62.6458C0.338924 65.2239 0.208272 67.8147 0.217768 70.4069C0.217768 71.4064 0.217768 72.3741 0.249332 73.3419Z"
          fill="white"
        />
      </g>
      <path d="M140 72.7998H0V74.1998H140V72.7998Z" fill="#B7BEC5" />
      <path d="M72.7999 74.2V0H71.3999V74.2H72.7999Z" fill="#B7BEC5" />
      <path
        d="M114.322 67.2002H125.058C125.378 67.2005 125.695 67.2649 125.989 67.3895C126.282 67.5141 126.547 67.6964 126.766 67.9248C126.985 68.1533 127.154 68.4234 127.262 68.7182C127.37 69.0131 127.416 69.3265 127.395 69.6391L126.657 80.4653C126.615 81.0441 126.35 81.5856 125.917 81.9815C125.483 82.3775 124.913 82.5985 124.319 82.6002H115.06C114.467 82.5999 113.896 82.3791 113.463 81.9828C113.031 81.5865 112.768 81.0441 112.728 80.4653L112.003 69.6138C111.987 69.3048 112.034 68.9957 112.143 68.7051C112.252 68.4146 112.419 68.1484 112.636 67.923C112.852 67.6975 113.113 67.5172 113.403 67.393C113.693 67.2688 114.005 67.2031 114.322 67.2002Z"
        fill="#B7BEC5"
      />
      <path
        d="M115.375 67.1879C115.375 67.1879 109.55 62.2156 113.205 46.2002C119.172 50.9392 117.332 67.2002 117.332 67.2002L115.375 67.1879Z"
        fill="#ECEEF1"
      />
      <path
        d="M124.87 67.2002C124.87 67.2002 129.245 63.8882 126.489 53.2002C122.03 56.3452 123.398 67.2002 123.398 67.2002H124.87Z"
        fill="#ECEEF1"
      />
      <path
        d="M120.592 67.2001C120.592 67.2001 123.311 52.8915 120.592 40.6001C115.016 45.0962 118.944 67.2001 118.944 67.2001H120.592Z"
        fill="#ECEEF1"
      />
      <path
        d="M113.752 46.2002L117.6 67.2002H116.502C116.502 67.2002 108.582 60.7486 113.752 46.2002Z"
        fill="#B7BEC5"
      />
      <path
        d="M126 46.2002L122.714 67.2002L121.792 67.1464C121.792 67.1464 116.697 58.8923 126 46.2002Z"
        fill="#B7BEC5"
      />
      <path d="M118.618 42L120.4 67.2H119.399C119.399 67.2 112.755 58.6792 118.618 42Z" fill="#B7BEC5" />
      <path
        d="M92.2729 35H23.9147C22.3991 35 20.9456 35.5975 19.8739 36.6611C18.8022 37.7247 18.2002 39.1673 18.2002 40.6714V117.291C21.1693 120.53 24.4389 123.483 27.9656 126.113H34.4675C34.815 126.115 35.1476 126.253 35.3928 126.498C35.6379 126.742 35.7755 127.073 35.7755 127.418V131.155C45.2104 136.382 55.7329 139.379 66.525 139.913C77.317 140.448 88.0878 138.505 98.0002 134.236V40.6714C98.0002 39.9255 97.8519 39.187 97.564 38.4982C97.276 37.8093 96.854 37.1835 96.322 36.6566C95.79 36.1298 95.1585 35.7123 94.4638 35.4281C93.769 35.1438 93.0245 34.9983 92.2729 35Z"
        fill="white"
      />
      <path
        d="M36.4 127.449C36.4 127.066 36.2519 126.698 35.988 126.427C35.7242 126.155 35.3661 126.002 34.992 126H28C30.6754 128.056 33.4817 129.926 36.4 131.6V127.449Z"
        fill="#ECEEF1"
      />
      <path
        d="M34.6613 64.6445H26.7516C26.0299 64.6445 25.4448 65.2307 25.4448 65.954V73.8795C25.4448 74.6026 26.0299 75.1888 26.7516 75.1888H34.6613C35.383 75.1888 35.9681 74.6026 35.9681 73.8795V65.954C35.9681 65.2307 35.383 64.6445 34.6613 64.6445Z"
        fill="#ECEEF1"
      />
      <path
        d="M34.6613 108.188H26.7516C26.0299 108.188 25.4448 108.774 25.4448 109.497V117.422C25.4448 118.146 26.0299 118.732 26.7516 118.732H34.6613C35.383 118.732 35.9681 118.146 35.9681 117.422V109.497C35.9681 108.774 35.383 108.188 34.6613 108.188Z"
        fill="#ECEEF1"
      />
      <path
        d="M89.9861 68.1171H48.7769C48.6095 68.1171 48.4489 68.0505 48.3305 67.9319C48.2122 67.8132 48.1455 67.6523 48.1455 67.4846C48.1455 67.3167 48.2122 67.1559 48.3305 67.0373C48.4489 66.9187 48.6095 66.8521 48.7769 66.8521H89.9861C90.1534 66.8521 90.3139 66.9187 90.4324 67.0373C90.5508 67.1559 90.6173 67.3167 90.6173 67.4846C90.6173 67.6523 90.5508 67.8132 90.4324 67.9319C90.3139 68.0505 90.1534 68.1171 89.9861 68.1171Z"
        fill="#E6E6E6"
      />
      <path
        d="M89.9864 72.9809H48.7773C48.6098 72.9809 48.4492 72.9142 48.3308 72.7956C48.2125 72.6769 48.146 72.5161 48.146 72.3483C48.146 72.1806 48.2125 72.0198 48.3308 71.901C48.4492 71.7825 48.6098 71.7158 48.7773 71.7158H89.9864C90.1538 71.7158 90.3144 71.7825 90.4327 71.901C90.5512 72.0198 90.6177 72.1806 90.6177 72.3483C90.6177 72.5161 90.5512 72.6769 90.4327 72.7956C90.3144 72.9142 90.1538 72.9809 89.9864 72.9809Z"
        fill="#E6E6E6"
      />
      <path
        d="M48.7773 111.661C48.6098 111.661 48.4492 111.594 48.3308 111.475C48.2125 111.357 48.146 111.196 48.146 111.028C48.146 110.86 48.2125 110.699 48.3308 110.581C48.4492 110.462 48.6098 110.396 48.7773 110.396H89.9864C90.1538 110.396 90.3144 110.462 90.4327 110.581C90.5512 110.699 90.6177 110.86 90.6177 111.028C90.6177 111.196 90.5512 111.357 90.4327 111.475C90.3144 111.594 90.1538 111.661 89.9864 111.661H48.7773Z"
        fill="#E6E6E6"
      />
      <path
        d="M89.9864 116.524H48.7773C48.6098 116.524 48.4492 116.458 48.3308 116.339C48.2125 116.22 48.146 116.06 48.146 115.892C48.146 115.724 48.2125 115.563 48.3308 115.444C48.4492 115.326 48.6098 115.259 48.7773 115.259H89.9864C90.1538 115.259 90.3144 115.326 90.4327 115.444C90.5512 115.563 90.6177 115.724 90.6177 115.892C90.6177 116.06 90.5512 116.22 90.4327 116.339C90.3144 116.458 90.1538 116.524 89.9864 116.524Z"
        fill="#E6E6E6"
      />
      <path
        d="M89.9864 129.124H48.7773C48.6098 129.124 48.4492 129.058 48.3308 128.939C48.2125 128.82 48.146 128.66 48.146 128.492C48.146 128.324 48.2125 128.163 48.3308 128.045C48.4492 127.926 48.6098 127.859 48.7773 127.859H89.9864C90.1538 127.859 90.3144 127.926 90.4327 128.045C90.5512 128.163 90.6177 128.324 90.6177 128.492C90.6177 128.66 90.5512 128.82 90.4327 128.939C90.3144 129.058 90.1538 129.124 89.9864 129.124Z"
        fill="#E6E6E6"
      />
      <path
        d="M89.9864 133.989H48.7773C48.6098 133.989 48.4492 133.922 48.3308 133.803C48.2125 133.685 48.146 133.524 48.146 133.356C48.146 133.188 48.2125 133.028 48.3308 132.909C48.4492 132.79 48.6098 132.724 48.7773 132.724H89.9864C90.1538 132.724 90.3144 132.79 90.4327 132.909C90.5512 133.028 90.6177 133.188 90.6177 133.356C90.6177 133.524 90.5512 133.685 90.4327 133.803C90.3144 133.922 90.1538 133.989 89.9864 133.989Z"
        fill="#E6E6E6"
      />
      <path
        d="M105.451 78.3999H34.5492C31.7053 78.3999 29.3999 80.6879 29.3999 83.5102V94.2896C29.3999 97.1119 31.7053 99.3999 34.5492 99.3999H105.451C108.295 99.3999 110.6 97.1119 110.6 94.2896V83.5102C110.6 80.6879 108.295 78.3999 105.451 78.3999Z"
        fill="#1D1D1F"
      />
      <path
        d="M45.9849 82.6001H39.4149C37.7498 82.6001 36.3999 83.95 36.3999 85.6151V92.1851C36.3999 93.8502 37.7498 95.2001 39.4149 95.2001H45.9849C47.65 95.2001 48.9999 93.8502 48.9999 92.1851V85.6151C48.9999 83.95 47.65 82.6001 45.9849 82.6001Z"
        fill="#ECEEF1"
      />
      <path
        d="M103.394 88.1999H59.0056C58.5798 88.1999 58.1713 88.0523 57.8702 87.7898C57.569 87.5273 57.3999 87.1712 57.3999 86.7999C57.3999 86.4286 57.569 86.0725 57.8702 85.81C58.1713 85.5475 58.5798 85.3999 59.0056 85.3999H103.394C103.82 85.3999 104.229 85.5475 104.53 85.81C104.831 86.0725 105 86.4286 105 86.7999C105 87.1712 104.831 87.5273 104.53 87.7898C104.229 88.0523 103.82 88.1999 103.394 88.1999Z"
        fill="#ECEEF1"
      />
      <path
        d="M93.6119 93.8H58.9879C58.5667 93.8 58.1628 93.6524 57.865 93.3899C57.5672 93.1274 57.3999 92.7713 57.3999 92.4C57.3999 92.0287 57.5672 91.6726 57.865 91.4101C58.1628 91.1476 58.5667 91 58.9879 91H93.6119C94.0331 91 94.437 91.1476 94.7348 91.4101C95.0326 91.6726 95.1999 92.0287 95.1999 92.4C95.1999 92.7713 95.0326 93.1274 94.7348 93.3899C94.437 93.6524 94.0331 93.8 93.6119 93.8Z"
        fill="#ECEEF1"
      />
      <path
        d="M83.962 47.9994L82.4442 42C80.042 43.1837 78.3999 45.5595 78.3999 48.3C78.3999 51.0406 80.042 53.4171 82.4442 54.6L83.962 48.6006C84.0125 48.4029 84.0125 48.1971 83.962 47.9994Z"
        fill="#1D1D1F"
      />
      <path
        d="M86.2306 40.6015C84.9221 40.5766 83.6876 40.8786 82.6001 41.4278L90.4138 48.1688C90.4947 48.2385 90.4947 48.3631 90.4138 48.4319L82.6001 55.1729C83.6456 55.7001 84.8272 56.0001 86.0797 56.0001C90.3988 56.0001 93.8903 52.4627 93.7983 48.1349C93.7123 44.0283 90.3478 40.6813 86.2306 40.6015Z"
        fill="#1D1D1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_5586_289768">
        <rect width="140" height="140" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'IconEmpty',
});
</script>
